module.exports = __webpack_public_path__ + "img/where the wind priestess is.1cc58ccb.png";